var _polygon, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#004FAC"
    },
    points: "478.609,55.652 478.609,55.652 478.609,22.261 33.391,22.261 33.391,55.652 33.391,55.652  0,55.652 0,456.348 33.391,456.348 33.391,489.739 478.609,489.739 478.609,456.348 512,456.348 512,55.652 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "512,155.826 0,155.826 0,456.348 33.391,456.348 33.391,489.739 478.609,489.739  478.609,456.348 512,456.348 "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "478.609,55.652 478.609,155.826 33.391,155.826 33.391,55.652 0,55.652 0,456.348 33.391,456.348 33.391,189.217  478.609,189.217 478.609,456.348 512,456.348 512,55.652 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.391,
    y: 22.261,
    width: 445.217,
    height: 33.391
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.391,
    y: 456.348,
    width: 445.217,
    height: 33.391
  })), /*#__PURE__*/React.createElement("rect", {
    x: 411.826,
    y: 89.043,
    style: {
      fill: "#A5001E"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 89.043,
    style: {
      fill: "#00CCB3"
    },
    width: 33.391,
    height: 33.391
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.913,
    y: 233.739,
    width: 356.174,
    height: 33.391
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.913,
    y: 311.652,
    width: 178.087,
    height: 33.391
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/WebDev.b8411a87fa32e9ca7c4c118d4e30e14a.svg";
export { ForwardRef as ReactComponent };